var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.shows,
      expression: "shows"
    }],
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.go
    }
  }, 'v-btn', _vm.props_btn, false), [_c('v-badge', _vm._b({
    attrs: {
      "bordered": "",
      "color": "error"
    }
  }, 'v-badge', {
    content: _vm.content
  }, false), [_c('v-icon', [_vm._v("mdi-gift-outline")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }